import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileService } from '../../services/file.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

export interface DialogData {
  fileId: string;
  professionalId: string;
  mimetype: string;
}

@Component({
  selector: 'app-modal-pdf-viewer',
  templateUrl: './modal-pdf-viewer.component.html',
  styleUrls: ['./modal-pdf-viewer.component.scss'],
})
export class ModalPdfViewerComponent {
  pdfSrc: SafeUrl;

  constructor(
    private fileService: FileService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<ModalPdfViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    fileService.getFile(data.fileId).subscribe((result) => {
      this.pdfSrc =
        data.mimetype === 'application/pdf'
          ? result
          : this.sanitizer.bypassSecurityTrustUrl(result);
    });
  }
}
